/* =============================================================================================
 * rb-pdp.js — hanh vi cua trang san pham moi.
 *
 * Nho: gallery, chon bien the va gio hang VAN do Horizon lo. File nay khong dung vao do.
 * No chi lam hai viec:
 *   1. Mo/dong FAQ bang <button> that + aria-expanded (khong dung <details> de con dieu khien
 *      duoc chieu cao va ton trong prefers-reduced-motion).
 *   2. Danh dau o anh nho dang chon, phong khi Horizon doi ten thuoc tinh trang thai.
 *
 * Uy quyen su kien tren `document` chu khong gan vao tung nut: khoi san pham cua Horizon bi
 * VE LAI moi lan doi bien the, nen listener gan truc tiep se bien mat sau lan chon mau dau tien.
 * ============================================================================================= */
(() => {
  const KHONG_DONG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function dat(nut, mo) {
    const o = document.getElementById(nut.getAttribute('aria-controls'));
    if (!o) return;
    nut.setAttribute('aria-expanded', mo ? 'true' : 'false');
    if (KHONG_DONG.matches) {
      o.style.height = mo ? 'auto' : '0px';
      return;
    }
    if (mo) {
      o.style.height = o.scrollHeight + 'px';
      o.addEventListener('transitionend', function xong(e) {
        if (e.propertyName !== 'height') return;
        o.removeEventListener('transitionend', xong);
        if (nut.getAttribute('aria-expanded') === 'true') o.style.height = 'auto';
      });
    } else {
      o.style.height = o.scrollHeight + 'px';
      requestAnimationFrame(() => { o.style.height = '0px'; });
    }
  }

  document.addEventListener('click', (e) => {
    const nut = e.target.closest('.rbp-faq__q');
    if (!nut) return;
    dat(nut, nut.getAttribute('aria-expanded') !== 'true');
  });

  // Cua so doi be ngang thi hang chu xuong dong khac di — o dang mo phai do lai chieu cao.
  let hen;
  window.addEventListener('resize', () => {
    clearTimeout(hen);
    hen = setTimeout(() => {
      document.querySelectorAll('.rbp-faq__q[aria-expanded="true"]').forEach((nut) => {
        const o = document.getElementById(nut.getAttribute('aria-controls'));
        if (o) o.style.height = 'auto';
      });
    }, 150);
  });

  /* --- O anh nho dang chon -------------------------------------------------------------------
     Horizon danh dau o dang chon bang mot trong may thuoc tinh tuy phien ban. CSS da phu ca ba,
     day chi la luoi an toan: dong bo them mot class rieng cua minh de kieu dang khong phu thuoc
     vao ten thuoc tinh cua theme. */
  function dongBoAnhNho() {
    document.querySelectorAll('.slideshow-controls__thumbnails').forEach((hop) => {
      const os = hop.querySelectorAll('.slideshow-controls__thumbnail');
      os.forEach((o) => {
        const chon =
          o.getAttribute('aria-current') === 'true' ||
          o.getAttribute('aria-selected') === 'true' ||
          o.hasAttribute('data-selected') ||
          o.classList.contains('slideshow-control--selected') ||
          o.classList.contains('is-active');
        o.classList.toggle('is-selected', chon);
      });
    });
  }

  const theoDoi = new MutationObserver(dongBoAnhNho);
  function batDau() {
    dongBoAnhNho();
    document.querySelectorAll('.slideshow-controls__thumbnails').forEach((hop) => {
      theoDoi.observe(hop, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'aria-selected', 'class', 'data-selected'] });
    });
  }

  /* --- Tieu de vua MOT HANG khi con doc duoc --------------------------------------------------
     Chu chot 14/08/2026: "ten san pham neu co the hay viet thanh 1 hang".
     CSS mot minh khong lam duoc — no khong do duoc be rong chu. Nen do that: dung mot the do
     an, cho no dung ho chu / do dam / gian chu cua chinh the h1, roi tinh ti le can thu nho.

     Co san: 21px tren dien thoai, 30px tren may tinh (ha tu 24 xuong 21 ngay 14/08 theo lenh
     chu "1 hang tren mobile" — 21px van lon hon than bai 16px nen doc ra ngay la tieu de). Duoi san thi de nguyen XUONG DONG —
     mot hang duy nhat nhung chu nho li ti thi te hon hai hang doc duoc. Do la y nghia cua
     chu "neu co the" trong lenh. */
  /* Bộ nhớ tạm + canvas đo chữ cho vuaMotHang() — xem chú thích dài trong hàm đó. */
  let _rbCanvas;

  /* ⚠️ 26/08/2026 — CỔNG TỰ TẮT: hàm này ĐANG TÍNH ĐÚNG NHƯNG CSS KHÔNG DÙNG KẾT QUẢ.
     Đo trên live (390x844, UA iPhone), /products/no-pull-reflective-dog-harness:
       inline style của h1 CÓ `--rbp-h1-size: 22px` và class `rbp-h1-1dong` CÓ được gắn,
       nhưng computed font-size vẫn **28px** và h1 vẫn **2 dòng, cao 63px**.
     ⇒ Hàm chạy đủ, đặt đủ, rồi không đổi được một pixel nào. CPU profiler (4x throttle):
       **178 ms** đổi lấy KHÔNG GÌ CẢ — tốn nhất trong mã của dự án trên PDP.

     ⚠️ NGUYÊN NHÂN KHÔNG PHẢI "thua độ đặc hiệu" như ghi chú cũ đoán — mà là THỨ TỰ NẠP.
     Đo bằng CSS.getMatchedStylesForNode, ba tệp cùng khai cho CHÍNH class này:
       rb-pdp.css            .rbx-pdp .product-details h1.rbp-h1-1dong { font-size: var(--rbp-h1-size) !important; white-space: nowrap !important }
       rb-hydrogen-typo.css  …h1.rbp-h1-1dong, .rbx-pdp .product-information .product-details h1 { font-size: 28px !important }
       rbh-token.css         …h1.rbp-h1-1dong, … { white-space: normal !important }
     Cùng độ đặc hiệu + cùng !important ⇒ tệp nạp SAU thắng. Hai tệp sau CỐ Ý gộp class này
     vào selector list của chúng để ép 28px, nên đây có thể là chủ ý chứ không phải tai nạn.

     Nên cổng dưới đây KHÔNG xoá tính năng — nó THỬ một lần mỗi lượt tải xem CSS có áp được
     không, và chỉ tắt khi câu trả lời là không. Ai sửa thứ tự nạp hay gỡ luật 28px thì hàm
     TỰ SỐNG LẠI, không phải nhớ bật gì.
     ⚠️ Phép thử dùng 11px — một cỡ không luật nào khai, nên nếu computed đổi thì chắc chắn là
     do biến của mình chứ không phải trùng với giá trị sẵn có. */
  /* ⚠️ 26/08/2026, LẦN THỨ HAI TRONG NGÀY — PHÉP THỬ ĐỘNG ĐÃ BỊ GỠ, ĐỌC TRƯỚC KHI ĐỊNH DỰNG LẠI.
     Bản đầu của cổng này thử động: đặt --rbp-h1-size:11px + gắn class rồi so computed font-size
     trước/sau, để tính năng TỰ SỐNG LẠI nếu ai sửa CSS. Ý hay, và **đo ra là vô nghĩa**:
       vuaMotHang (thứ nó tránh)  178 ms
       _rbThuCss  (phép thử)      164 ms
     Phép thử đắt gần bằng cả hàm — vì mọi getComputedStyle sau khi đổi class đều ép tính lại
     style/layout trên 21 tệp CSS (~409 KB) của PDP, và đó mới là thứ tốn tiền, không phải số
     phép tính. **Một phép thử để tránh chi phí mà đắt bằng chính chi phí đó thì không phải tối
     ưu, chỉ là đổi tên dòng chi.**

     Nên nay là hằng số. Muốn bật lại tính năng thu cỡ chữ H1 thì phải làm ĐÚNG THỨ TỰ:
       ① sửa CSS trước — gỡ .rbx-pdp .product-details h1.rbp-h1-1dong khỏi selector list ép
         28px !important trong rb-hydrogen-typo.css, và khỏi luật white-space:normal !important
         trong rbh-token.css (hai tệp đó nạp SAU rb-pdp.css nên đang thắng);
       ② đo lại trên live rằng đặt tay --rbp-h1-size có đổi được font-size;
       ③ rồi mới đổi dòng dưới thành true.
     Làm ngược (bật JS trước) là trả lại 178 ms để đổi lấy vẫn không gì cả. */
  function _rbThuCss() { return false; }
  let _rbMemo = '';

  const SAN_DI_DONG = 21;
  const SAN_MAY_TINH = 30;

  function vuaMotHang() {
    const h1 = document.querySelector('.product-details h1');
    if (!h1) return;
    if (!_rbThuCss(h1)) return;   // CSS không dùng --rbp-h1-size -> mọi phép đo bên dưới là vô ích

    /* ⚠️ 23/08/2026 — GIẢM ÉP TÍNH LẠI BỐ CỤC.
       Đo bằng CPU profiler của Chrome (4x throttle, 390x844, UA iPhone) trên
       /products/front-chest-dog-carrier: hàm này chiếm **450 ms** — tốn nhất trong toàn bộ mã
       của dự án trên PDP (bundle lõi Shopify 5.395 ms là phần còn lại, không sửa được).
       Bản cũ, MỖI lượt gọi ép trình duyệt tính lại bố cục sáu lần:
         gỡ class + gỡ biến  -> vô hiệu bố cục
         đọc h1.clientWidth  -> ÉP tính lại
         getComputedStyle    -> ÉP tính lại style
         chèn <span> vào body, đọc getBoundingClientRect -> ÉP tính lại LẦN NỮA
         remove()            -> lại vô hiệu
       Trang này nạp 21 tệp CSS (~409 KB) nên mỗi lần tính lại là một lượt duyệt toàn bộ quy tắc.
       Hàm được gọi ÍT NHẤT hai lần mỗi lượt tải (chay + document.fonts.ready), cộng
       resize / variant:update / shopify:section:load.

       Hai thay đổi:
       1. Đo bằng canvas measureText — cho cùng con số mà KHÔNG chạm DOM, không ép layout.
       2. Bộ nhớ tạm theo (chữ | bề rộng ô | bề rộng cửa sổ) để lượt gọi lặp thoát ngay.

       ⚠️ canvas KHÔNG biết text-transform và letter-spacing, phải tự xử lý. "capitalize" không
       quy đổi được bằng chuỗi nên VẪN đi đường <span> cũ — giữ nhánh dự phòng, đừng gỡ. Ai đổi
       CSS h1 sang capitalize thì nó tự rơi về đường cũ, không vỡ.
       ⚠️ Đọc h1.clientWidth TRƯỚC khi gỡ class: class chỉ đổi font-size, không đổi bề rộng khối
       h1, nên số đọc được vẫn đúng — và nhờ vậy bộ nhớ tạm mới so sánh được trước khi đụng DOM. */
    const chu = h1.textContent.trim();
    const rongO = h1.clientWidth;
    if (!rongO) return;

    const khoa = chu + '|' + rongO + '|' + window.innerWidth;
    if (_rbMemo === khoa && h1.classList.contains('rbp-h1-1dong')) return;

    // Ve lai trang thai goc truoc khi do, neu khong lan do thu hai se do chinh ket qua lan dau.
    h1.classList.remove('rbp-h1-1dong');
    h1.style.removeProperty('--rbp-h1-size');

    const cs = getComputedStyle(h1);
    const coHienTai = parseFloat(cs.fontSize);
    if (!coHienTai) return;

    const tt = cs.textTransform;
    let t = chu;
    if (tt === 'uppercase') t = chu.toUpperCase();
    else if (tt === 'lowercase') t = chu.toLowerCase();

    let rongChu;
    if (tt === 'none' || tt === 'uppercase' || tt === 'lowercase') {
      _rbCanvas = _rbCanvas || document.createElement('canvas').getContext('2d');
      _rbCanvas.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + coHienTai + 'px ' + cs.fontFamily;
      rongChu = _rbCanvas.measureText(t).width;
      const ls = parseFloat(cs.letterSpacing);
      if (ls) rongChu += ls * Math.max(0, t.length - 1);
    } else {
      const do_ = document.createElement('span');
      do_.textContent = chu;
      do_.style.cssText =
        'position:absolute;left:-9999px;top:0;white-space:nowrap;visibility:hidden;' +
        'font-family:' + cs.fontFamily + ';font-weight:' + cs.fontWeight + ';' +
        'font-size:' + coHienTai + 'px;letter-spacing:' + cs.letterSpacing + ';' +
        'text-transform:' + tt + ';font-style:' + cs.fontStyle;
      document.body.appendChild(do_);
      rongChu = do_.getBoundingClientRect().width;
      do_.remove();
    }
    if (!rongChu) return;

    const san = window.innerWidth >= 990 ? SAN_MAY_TINH : SAN_DI_DONG;
    // 0.995: chua mot sat rat mong cho sai so lam tron cua trinh duyet.
    const canCo = Math.floor(coHienTai * (rongO / rongChu) * 0.995);
    const co = Math.min(canCo, coHienTai);   // chi thu NHO lai, khong bao gio phong to
    if (co < san) return;                    // qua nho -> giu xuong dong

    h1.style.setProperty('--rbp-h1-size', co + 'px');
    h1.classList.add('rbp-h1-1dong');
    _rbMemo = khoa;
  }

  /* ⚠️ 24/08/2026 — ĐÃ GỠ MỘT DẤU `}` THỪA Ở NGAY TRÊN DÒNG NÀY. ĐỪNG THÊM LẠI.

     Dấu đó lọt vào theo bản vá `12-h1-bot-ep-bo-cuc.json` (đổi vuaMotHang sang canvas.measureText)
     ngày 23/08: bản vá thêm dấu đóng cho khối mới mà không gỡ dấu cũ. Nó đóng luôn IIFE bao ngoài,
     nên `function chay()` rơi ra ngoài và cả tệp thành SyntaxError.

     HẬU QUẢ ĐO ĐƯỢC (Chrome 390px, CPU 4x, cache tắt, 24/08):
       `Uncaught SyntaxError: Unexpected token 'function' @ rb-pdp.js`
     ⇒ TOÀN BỘ tệp không chạy trên MỌI trang sản phẩm suốt từ 23/08:
       · dat()           — bật/tắt khối nội dung
       · dongBoAnhNho()  — đồng bộ ảnh nhỏ trong gallery
       · batDau()        — khởi động
       · vuaMotHang()    — thu cỡ chữ H1
       · chay()          — điểm vào
       · 7 addEventListener

     ⚠️ VÌ SAO KHÔNG CỔNG NÀO BẮT ĐƯỢC: mọi cổng của dự án đọc MÃ NGUỒN hoặc đo BỐ CỤC. Một tệp JS
     chết vì lỗi cú pháp thì trang vẫn render, vẫn đủ chữ, vẫn đúng bố cục — chỉ là không có tương
     tác. Cùng họ với `rb-cham.css` (khai đúng, tệp 404) và với chính bài học *"khai đúng KHÔNG
     đồng nghĩa tới nơi"*. Thứ bắt được nó là nghe `Runtime.exceptionThrown` trên TRANG THẬT.

     ⚠️ Và bản vá 23/08 đã "nghiệm thu" bằng cách đo `vuaMotHang` biến mất khỏi bảng CPU profiler —
     nó BIẾN MẤT thật, nhưng vì cả tệp chết chứ không phải vì tối ưu thành công. Một phép đo đúng
     hướng vẫn kết luận sai khi nó chỉ nhìn MỘT mặt. Từ nay vá JS xong phải chạy `node --check`
     trên bản sẽ đẩy, và đọc console của trang thật sau khi đẩy. */

  function chay() {
    batDau();
    vuaMotHang();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }
  // Font tai xong thi be rong chu doi -> do lai, neu khong lan do dau la do bang font du phong.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(vuaMotHang);
  window.addEventListener('resize', () => { clearTimeout(hen); hen = setTimeout(vuaMotHang, 160); });
  // Khoi san pham duoc ve lai khi doi bien the -> gan lai observer va do lai tieu de.
  document.addEventListener('variant:update', chay);
  document.addEventListener('shopify:section:load', chay);
})();
